import React, { useEffect } from 'react'
import fetchPatientData from '../../services/general/patientGeneralAPI.api';

const Summary = ({ patientData, vitalsList, setActiveTab }) => {

    const vitalFields = [
        { name: 'bloodPressure', label: 'Blood Pressure', unit: 'mmHg' },
        { name: 'heartRate', label: 'Heart Rate', unit: 'bpm' },
        { name: 'respiratoryRate', label: 'Respiratory Rate', unit: 'rpm' },
        { name: 'temperature', label: 'Temperature', unit: '°F' },
        { name: 'spO2', label: 'SpO2', unit: '%' },
        { name: 'inhaledO2', label: 'Inhaled O2', unit: '%' },
        { name: 'heartCirc', label: 'Heart Circ', unit: 'in' },
        { name: 'height', label: 'Height', unit: 'ft/in' },
        { name: 'weight', label: 'Weight', unit: 'lbs/oz' },
    ];

    const partitionVitals = (vitalFields, size) => {
        const result = [];
        for (let i = 0; i < vitalFields.length; i += size) {
            result.push(vitalFields.slice(i, i + size));
        }
        return result;
    };

    const getData = async () => {
        console.log(patientData, patientData)
        let allVital = { PatientID: patientData.PatientID }
        allVital = [allVital]
        let allData = await fetchPatientData("GETALL", "Vitals", JSON.stringify(allVital))
    }

    useEffect(() => {
        getData()
    }, [])

    return (
        <>
            <div class="container main-container">
                <div class="row">
                    {/* <div class="col-3">
                        <div class="summary-col profile">
                        </div>
                        <div class="summary-col">
                            <div class="sub_heading">Patient Type</div>
                            <div class="summary_color_heading">New Patient</div>
                        </div>
                        <div class="summary-col summary-col-information">
                        </div>
                    </div> */}

                    <div className='col-6'>

                        <div class="card-body p-0 ">
                            <div class="row mb-2 vital">
                                <div onClick={() => { setActiveTab(5) }} class="col-md-12 underline-hover add-prescription">Vital Signs</div>
                            </div>
                        </div>

                        <div class="card-body p-0 ">
                            <div class="row mb-2">
                                <div class="col-md-12">
                                    <div class="row facility-custom ">
                                        <div className='d-flex custom-table-responsive'>
                                            <div className='row overflow_x_auto '>
                                                {partitionVitals(vitalFields, 4).map((items, i) => {
                                                    return (
                                                        <div className='col-12'>
                                                            <div className='row '>
                                                                {items.map((item, i) => {
                                                                    return (
                                                                        <div class="col-md-6">
                                                                            <div class="card">
                                                                                <div class="card-body">
                                                                                    <h6>{item.label}</h6>
                                                                                    <p className='fw-medium'><span className='fw-bold'>{vitalsList.length > 0 && vitalsList[0][item.name]}</span>{item.unit}</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                        {/* medicines */}
                        <div class="card-body p-0 ">
                            <div class="text-records priscriptions">
                                <h6 className='underline-hover' onClick={() => { setActiveTab(8) }}>Medicines</h6>
                                <hr />
                                <div class="row mt-3 ">
                                    <div class="col-md-6">
                                        <div class="card">
                                            <div class="card-body">
                                                <p class="disease text-center">Heart Disease</p>
                                                <p class="duration">3 Months</p>
                                                <p class="duration-form-to">25 Dec 2020 - 25 Feb 2021</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="card">
                                            <div class="card-body">
                                                <p class="disease text-center">Skin Care</p>
                                                <p class="duration">2 Months</p>
                                                <p class="duration-form-to">25 Dec 2020 - 25 Feb 2021</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="card">
                                            <div class="card-body">
                                                <p class="disease text-center">Skin Care</p>
                                                <p class="duration">2 Months</p>
                                                <p class="duration-form-to">25 Dec 2020 - 25 Feb 2021</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="card">
                                            <div class="card-body">
                                                <p class="disease text-center">Diabetes Disease</p>
                                                <p class="duration">12 Months</p>
                                                <p class="duration-form-to">25 Dec 2020 - 25 Feb 2021</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>


                    <div className='col-6'>

                        <div class="card-body p-0 ">
                            <div class="text-records mb-4  ">
                                <h6 className='underline-hover'>Diagnosis</h6>
                                <hr />
                                <div class="row ">
                                    <div className="summary-first-row overflow_x_auto ">
                                        {
                                            patientData?.Diagnosis
                                                ? patientData.Diagnosis.split(",").map((item) => {
                                                    return (
                                                        <div className="summary-first-col whitescpace-nowrap" key={item}>{item}</div>
                                                    );
                                                })
                                                : <div className="summary-first-col">No Diagnosis</div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card-body p-0 ">
                            <div class="text-records mb-4 ">
                                <h6 onClick={() => { setActiveTab(7) }} className='underline-hover'>Lab Reports</h6>
                                <hr />
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="d-flex gap-2 align-items-center">
                                                    {/* <div class="report-icon color-1"><img src="images/report.png" alt="icon"></div> */}
                                                    <div>
                                                        <h6 className='fw-light opacity-75'>CT Scan - Abdomen</h6>
                                                        <p>Details...</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="d-flex gap-2 align-items-center">
                                                    {/* <div class="report-icon color-2"><img src="images/report.png" alt="icon"></div> */}
                                                    <div>
                                                        <h6 className='fw-light opacity-75'>Blood Test</h6>
                                                        <p>Details...</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="d-flex gap-2 align-items-center">
                                                    {/* <div class="report-icon color-3"><img src="images/report.png" alt="icon"></div> */}
                                                    <div>
                                                        <h6 className='fw-light opacity-75'>Pathology Test</h6>
                                                        <p>Details...</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="d-flex gap-2 align-items-center">
                                                    {/* <div class="report-icon color-2"><img src="images/report.png" alt="icon"></div> */}
                                                    <div>
                                                        <h6 className='fw-light opacity-75'>Blood Test</h6>
                                                        <p>Details...</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>

                    <div class="col-12 custom-table-responsive">
                    </div>
                </div>
            </div>
        </>
    )
}

export default Summary